var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleRadio = function SvgCircleRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1494 12C20.1494 7.49901 16.5009 3.84982 12 3.84961C7.49888 3.84961 3.84961 7.49888 3.84961 12C3.84982 16.5009 7.49901 20.1494 12 20.1494C16.5008 20.1492 20.1492 16.5008 20.1494 12ZM8 12C8 9.79086 9.79086 8 12 8C14.2087 8.00053 16 9.79119 16 12C15.9995 14.2084 14.2084 15.9995 12 16C9.79119 16 8.00053 14.2087 8 12ZM22.1494 12C22.1492 17.6054 17.6054 22.1492 12 22.1494C6.39444 22.1494 1.84982 17.6055 1.84961 12C1.84961 6.39431 6.39431 1.84961 12 1.84961C17.6055 1.84982 22.1494 6.39444 22.1494 12Z",
    fill: "currentColor"
  })));
};
export default SvgCircleRadio;